import React from "react"; // ✅ REQUIRED for SSR and JSX
import { LocalizeByCurrentUserPreferenceLanguage, LocalizeByLang } from "utilities/localize";
import { withSpinner } from "./withSpinner";
import { useSelector } from "react-redux";

/**
 * A customized hook which can utilize contentful state from redux in the exposed methods.
 */
const useLocalizer = () => {
    const { contentfulMasterData } = useSelector((state) => state);

    const localize = (key) => {
        return LocalizeByCurrentUserPreferenceLanguage(key, contentfulMasterData?.data?.items);
    };
    
    const localizeByLang = (key, lang) => {
        return LocalizeByLang(key, lang, contentfulMasterData?.data?.items);
    };
    return {
        localize,
        localizeByLang
    };
};

/**
 * A wrapper to expose the methods to localize functions.
 * This wrapper will include spinner wrapper automatically by default
 * 
 * Props:
 * - Component (component): a component, new methods will be spread by props
 */
export const withLocalizer = (Component) => {

    const Wrapper = (props) => {
        const { localize, localizeByLang } = useLocalizer();

        return (
            <Component
                localize={localize}
                localizeByLang={localizeByLang}
                {...props}
            />
        );
    };

    return withSpinner(Wrapper);
};